<template>
  <b-modal
    centered
    no-close-on-backdrop
    size="md"
    v-model="show"
    @hide="Cancel"
    :cancel-disabled="false"
    scrollable>
    <b-container fluid>
      <b-card-header class="p-0">
        <b-button-toolbar class="float-md-left">
          <b-button title="Check All" variant="link" @click="checkAll(true)">
            <b-icon icon="check-all" /> Check All
          </b-button>
          <b-button title="Check All" variant="link" @click="checkAll(false)">
            <b-icon icon="x-square" /> Uncheck All
          </b-button>
        </b-button-toolbar>
      </b-card-header>
      <b-row no-gutters class="w-100">
        <b-col class="w-100" v-if="topologyItem">
          <template v-if="topologyItem.CategoryId">
            <product-classes
              :topologyItem="topologyItem" :paddingLeft="paddingLeft">
            </product-classes>
          </template>
          <template v-if="topologyItem.ProductClassId">
            <manufacturing-series
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
          <template v-if="topologyItem.ManufacturingSeriesId">
            <products
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
          <template v-if="topologyItem.ProductId">
            <sections
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
          <template v-if="topologyItem.SeriesId === -2">
            <manufacturing-series
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
          <template v-if="topologyItem.length > 0 && !allCategories">
            <models
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
          <template v-if="topologyItem.length > 0 && allCategories">
            <categories
              :topologyItem="topologyItem" :paddingLeft="paddingLeft" />
          </template>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-header>
      <h3 v-if="topologyItem">
        {{ topologyItem.DisplayName }}
      </h3>
    </template>
    <template #modal-footer>
      <downloading-text v-if="downloading" />
      <b-button :class="downloading ? 'disabled' : ''" size="sm" variant="primary" @click="Export()">
        Export Data to Excel
      </b-button>
      <b-button
        variant="primary"
        size="sm"
        @click="show=false"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>
<script lang="ts">
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import Categories from './categories.vue'
import ProductClasses from './product-classes.vue'
import Product from './products.vue'
import ManufacturingSeries from './manufacturing-series.vue'
import Sections from './sections.vue'
import Models from './models.vue'
import { cloneDeep } from 'lodash'
import { namespace } from 'vuex-class'
import DownloadingText from '@/components/utility/downloading-text.vue'

const nsModelViewer = namespace('model-viewer')

@Component({
  components: {
    'product-classes': ProductClasses,
    'products': Product,
    'manufacturing-series': ManufacturingSeries,
    'sections': Sections,
    'models': Models,
    'categories': Categories,
    'downloading-text': DownloadingText,
  },
})

export default class extends Mixins() {
  @Prop()
  public show!: boolean

  @Prop()
  public topologyItem!: any

  @Prop({ default: null })
  public customer: any

  @Prop({ default: false })
  public showInventory!: boolean

  @Prop({ default: true })
  public showPrice!: boolean

  @Prop({ default: false })
  public allCategories!: boolean

  @nsModelViewer.Action('getCustomExportFile')
  public getCustomExportFile: any

  public paddingLeft: number = 2
  public downloading = false

  public Cancel() {
    this.$emit('close', false)
  }

  @Watch('show')
  public onShowChange(show: boolean) {
    if (show) {
      this.checkAll(true)
    }
  }

  public Export() {
    this.downloading = true
    let filteredItems = cloneDeep(this.topologyItem)
    if (filteredItems.CategoryId) {
      filteredItems = filteredItems.ProductClasses.filter(pc => pc.Download === true)
      filteredItems.forEach((pc) => {
        pc.ManufacturingSeries = pc.ManufacturingSeries.filter(ms => ms.Download === true)
        pc.ManufacturingSeries.forEach((ms) => {
          ms.Products = ms.Products.filter(p => p.Download === true)
        })
      })
      this.getCustomExportFile({ categoryId: this.topologyItem.CategoryId, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.ProductClassId) {
      filteredItems = filteredItems.ManufacturingSeries.filter(ms => ms.Download === true)
      filteredItems.forEach((ms) => {
        ms.Products = ms.Products.filter(p => p.Download === true)
      })
      this.getCustomExportFile({ productClassId: this.topologyItem.ProductClassId, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.ManufacturingSeriesId) {
      filteredItems = filteredItems.Products.filter(p => p.Download === true)
      this.getCustomExportFile({ manufacturingSeriesId: this.topologyItem.ManufacturingSeriesId, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.ProductId) {
      filteredItems = filteredItems.Sections.filter(p => p.Download === true)
      filteredItems.forEach((s) => {
        s.Tabs = s.Tabs.filter(t => t.Download === true)
        s.Tabs.forEach((t) => {
          t.Tables = t.Tables.filter(ta => ta.Download === true)
          t.Tables.forEach((m) => {
            m.Models = m.Models.filter(m => m.Download === true)
          })
        })
      })
      this.getCustomExportFile({ productId: this.topologyItem.ProductId, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.SeriesId === -2) {
      filteredItems = filteredItems.ManufacturingSeries.filter(ms => ms.Download === true)
      filteredItems.forEach((ms) => {
        ms.Products = ms.Products.filter(p => p.Download === true)
        ms.Products.forEach((p) => {
          p.Sections = p.Sections.filter(se => se.Download === true)
          p.Sections.forEach((s) => {
            s.Tabs = s.Tabs.filter(t => t.Download === true)
            s.Tabs.forEach((t) => {
              t.Tables = t.Tables.filter(ta => ta.Download === true)
              t.Tables.forEach((m) => {
                m.Models = m.Models.filter(m => m.Download === true)
              })
            })
          })
        })
      })
      this.getCustomExportFile({ seriesId: -2, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.length > 0 && !this.allCategories) {
      filteredItems = filteredItems.filter(m => m.Download === true)
      this.getCustomExportFile({ customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    } else if (filteredItems.length > 0 && this.allCategories) {
      filteredItems = filteredItems.filter(m => m.Download === true)
      filteredItems.forEach((c) => {
        c.ProductClasses = c.ProductClasses.filter(pc => pc.Download === true)
        c.ProductClasses.forEach((pc) => {
          pc.ManufacturingSeries = pc.ManufacturingSeries.filter(ms => ms.Download === true)
          pc.ManufacturingSeries.forEach((ms) => {
            ms.Products = ms.Products.filter(p => p.Download === true)
          })
        })
      })
      this.getCustomExportFile({ all: true, customerNumber: this.customer?.customerNo, showInventory: this.showInventory, showPricing: this.showPrice, data: filteredItems }).then(() => {
        this.downloading = false
      }).catch(() => {
        this.downloading = false
      })
    }
  }

  public checkAll(value: boolean) {
    if (this.topologyItem.CategoryId) {
      this.topologyItem.ProductClasses.forEach((pc) => {
        pc.Download = value
        pc.ManufacturingSeries.forEach((ms) => {
          ms.Download = value
          ms.Products.forEach((p) => {
            p.Download = value
          })
        })
      })
    } else if (this.topologyItem.ProductClassId) {
      this.topologyItem.ManufacturingSeries.forEach((ms) => {
        ms.Download = value
        ms.Products.forEach((p) => {
          p.Download = value
        })
      })
    } else if (this.topologyItem.ManufacturingSeriesId) {
      this.topologyItem.Products.forEach((p) => {
        p.Download = value
      })
    } else if (this.topologyItem.ProductId) {
      this.topologyItem.Sections.forEach((s) => {
        s.Download = value
        s.Tabs.forEach((t) => {
          t.Download = value
          t.Tables.forEach((m) => {
            m.Download = value
          })
        })
      })
    } else if (this.topologyItem.SeriesId === -2) {
      this.topologyItem.ManufacturingSeries.forEach((ms) => {
        ms.Download = value
        ms.Products.forEach((p) => {
          p.Download = value
          p.Sections.forEach((s) => {
            s.Download = value
            s.Tabs.forEach((t) => {
              t.Download = value
              t.Tables.forEach((m) => {
                m.Download = value
              })
            })
          })
        })
      })
    } else if (this.topologyItem.length > 0) {
      this.topologyItem.forEach((m) => {
        m.Download = value
        if (m.ProductClasses) {
          m.ProductClasses.forEach((pc) => {
            pc.Download = value
            pc.ManufacturingSeries.forEach((ms) => {
              ms.Download = value
              ms.Products.forEach((p) => {
                p.Download = value
              })
            })
          })
        }
      })
    }
  }
}
</script>
<style scoped></style>
